import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Slider from '../../app/components/slider';
import Lead from '../../Lead';
import image1 from '../../app/data/screenshots/spindal/kol2.jpg';
import image2 from '../../app/data/screenshots/spindal/lana.jpg';
import image3 from '../../app/data/screenshots/spindal/wiz.jpg';

const images = [
  {
    src: image1,
    alt: 'Spindal music player - control panel',
  },
  {
    src: image2,
    alt: 'Spindal music player full-screen',
  },
  {
    src: image3,
    alt: 'Spindal music player full-screen',
  },
];

const tags = [
  'Product Management',
  'Ember.js',
  'Ember Data',
  'UI Design',
  'CSS',
];

export default () => (
  <div>
    <Details
      title="Spindal"
      subtitle="Music"
    >
      <Details.Paragraph emoji="🎵" title="An ecommerce platform for music artists">
        Spindal makes it easy for music artists to promote their music, and sell their
        albums directly to their fans. Spindal cuts down the middleman and lets artists keep 100% of
        their profit. Through the product, a music artist can create their own online store,
        customize their store design, and add their albums for their fans to listen and purchase
        instantly.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="How we fixed and grew Spindal's product">
        Spindal approached us to help them fix issues with their existing web application. Due to
        poor development, the product suffered from a lot of bugs, which also made it hard to
        evolve and release new features. We focused on establishing best practices in product
        management, coding, testing, and releasing new features. We then proceeded to refactor the
        code and getting it well tested to improve the reliability of the product. As a result of
        our work, the client was able to grow their product and release new features faster.
      </Details.Paragraph>
      <Details.Tags tags={tags} />
      <Slider images={images} />
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/spindal.js